import { OrderListType } from '../api/apiConfig';

export async function groupOrderWithItemSubrow(data: OrderListType[]) {
  const groupedOrders = data.reduce<OrderListType[]>((acc, order) => {
    const {
      PROD_DES,
      SIZE_DES,
      PROD_CD,
      CLASS_CD,
      CLASS_CD_DES,
      CLASS_CD2,
      CLASS_CD2_DES,
      CLASS_CD3,
      CLASS_CD3_DES,
      QTY,
      PRICE,
      SUPPLY_AMT,
      ORDER_ID,
      ...rest
    } = order;

    // 이미 ORDER_ID가 존재하는 항목을 찾아서 해당 `subRows`에 품목 정보를 추가
    const existingOrder = acc.find((item) => item.ORDER_ID === ORDER_ID);
    if (existingOrder) {
      if (existingOrder.subRows?.some((subrow) => subrow.PROD_CD === PROD_CD)) {
        existingOrder.duplicated = true;
      }
      existingOrder.subRows?.push({
        PROD_DES,
        SIZE_DES,
        PROD_CD,
        CLASS_CD,
        CLASS_CD_DES,
        CLASS_CD2,
        CLASS_CD2_DES,
        CLASS_CD3,
        CLASS_CD3_DES,
        QTY,
        PRICE,
        SUPPLY_AMT,
        subRows: [], // 빈 배열로 초기화
      });
    } else {
      // 없으면 새로운 항목 추가
      acc.push({
        ORDER_ID,
        duplicated: false,
        subRows: [
          {
            PROD_DES,
            SIZE_DES,
            PROD_CD,
            CLASS_CD,
            CLASS_CD_DES,
            CLASS_CD2,
            CLASS_CD2_DES,
            CLASS_CD3,
            CLASS_CD3_DES,
            QTY,
            PRICE,
            SUPPLY_AMT,
            subRows: [], // 빈 배열로 초기화
          },
        ],
        ...rest, // 나머지 주문 정보
      });
    }

    return acc;
  }, []);
  return groupedOrders;
}

export function changeTimeStringToHourNumber(timeString: string) {
  // 정규식을 사용하여 HH:MM:SS 형식인지 검사
  const timeRegex = /^([01]?[0-9]|2[0-3]):([0-5]?[0-9]):([0-5]?[0-9])$/;

  if (!timeRegex.test(timeString)) {
    return undefined; // 형식이 맞지 않으면 undefined 반환
  }

  let [hourString, minString, secString] = timeString.split(':');
  let hour = Number(hourString);
  let meridiem: string = '';

  // 24시간제를 12시간제로 변환
  if (hour >= 12) {
    hour = hour === 12 ? hour : hour - 12; // 12시를 제외한 PM 시간은 12에서 빼기
    meridiem = 'PM';
  } else {
    meridiem = 'AM';
  }

  return { hour, meridiem };
}

//meridiem(AM or PM)값과 12이하의 숫자를 받아 0 이상, 23 이하의 시간을 기반하여 HH:MM:SS형식의 string으로 반환
export function changeHourNumberToTimeString(
  meridiem: string,
  numberHour: number
) {
  const changedHour = meridiem === 'AM' ? numberHour : numberHour + 12;
  return `${changedHour}:00:00`;
}
